import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { Section } from '../ui/Section';
type Testimonial = {
  quote: string;
  name: string;
  role: string;
  img: string;
};
const testimonials: Testimonial[] = [{
  quote: 'En menos de 3 minutos sé el subtono y la estación de cada clienta. Antes tardaba media hora y a veces igual fallaba.',
  name: 'Camila S.',
  role: 'Buenos Aires · Maquilladora profesional',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/bfef72ba-d7d4-4919-bc30-6312a0f17329.jpg'
}, {
  quote: 'Dejé de improvisar con ojeras y rojeces: ahora sé exactamente qué corrector usar y por qué.',
  name: 'Rocío D.',
  role: 'Rosario · Novias y eventos',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/b01475e4-e452-4ecf-a8af-fc315d8a8ae7.jpg'
}, {
  quote: 'Adapto la paleta según la estación de cada clienta en minutos; ya no pruebo combinaciones a ojo.',
  name: 'Antonella P.',
  role: 'Córdoba · Social y editorial',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/ef56208f-ea31-4a27-82ad-3d6ca695125b.jpg'
}, {
  quote: 'La ficha de diagnóstico me ordenó todo el servicio. Mi clienta entiende por qué le recomiendo cada color.',
  name: 'Lucía M.',
  role: 'Mendoza · Maquilladora independiente',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/330e0bb6-b4d8-47f6-94ba-d9447899e63c.jpg'
}, {
  quote: 'El tomo de pieles difíciles me dio seguridad para atender casos que antes evitaba.',
  name: 'Valentina R.',
  role: 'La Plata · Especialista en novias',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/0b7258f2-89aa-4e72-9bd8-c19b86f79f5f.jpg'
}, {
  quote: 'Ahora enseño colorimetría con un método claro. Mis alumnas por fin entienden cómo decidir una paleta.',
  name: 'Julieta G.',
  role: 'Salta · Makeup artist y docente',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/f1e22c68-48fa-4dd5-b38b-ba67a195db02.jpg'
}];
export function Testimonials() {
  return <Section className="bg-cream" data-id="element-244" data-mp="skz4gh92rqpa">
      <div className="mx-auto max-w-3xl" data-id="element-245" data-mp="sk79n8naxx02">
        <div className="text-center" data-id="element-246" data-mp="el7v4tti6yhm"><p className="text-[10px] font-semibold uppercase tracking-luxe text-rosegold sm:text-xs" data-id="element-247" data-mp="ejwfnwqp42ao">Historias reales</p><h2 className="mt-2 font-display text-3xl font-semibold leading-tight text-ink sm:text-4xl" data-id="element-248" data-mp="il88sc8s35nm">
</h2></div>
        <div className="mt-6 overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-rosegold/10 sm:mt-8 sm:rounded-3xl" data-id="element-249" data-mp="4tjz0fm04t9t">
          {testimonials.map((testimonial, index) => <TestimonialRow key={testimonial.name} testimonial={testimonial} index={index} data-id="element-250" data-mp="3r34e57sj047t" data-mpi={index} />)}
        </div>
      </div>
    </Section>;
}
function TestimonialRow({
  testimonial,
  index
}: {
  testimonial: Testimonial;
  index: number;
}) {
  return <motion.figure initial={{
    opacity: 0,
    y: 12
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-40px'
  }} transition={{
    duration: 0.3,
    delay: Math.min(index * 0.04, 0.16)
  }} className="flex items-center gap-3 border-b border-blush px-3 py-3 last:border-b-0 sm:gap-4 sm:px-5 sm:py-4" data-id="element-251" data-mp="3i2g8p1h77c6j">
      <img src={testimonial.img} alt={`Retrato de ${testimonial.name}`} loading="lazy" decoding="async" sizes="56px" className="h-12 w-12 shrink-0 rounded-full object-cover ring-2 ring-blush sm:h-14 sm:w-14" data-id="element-252" data-mp="2yhzc7r7g2mp3" />
      <figcaption className="min-w-0 flex-1" data-id="element-253" data-mp="38gf1rpqtpnwh"><div className="flex flex-wrap items-center gap-x-2 gap-y-0.5" data-id="element-254" data-mp="3md1ybrev6c1v"><span className="font-display text-base font-semibold leading-none text-ink sm:text-lg" data-id="element-255" data-mp="3mbh7ocvo7d9a">{testimonial.name}</span><span className="flex gap-0.5 text-rosegold" aria-label="5 de 5 estrellas" data-id="element-256" data-mp="3w3dgahvdulrr">{Array.from({
            length: 5
          }).map((_, star) => <StarIcon key={star} className="h-2.5 w-2.5 fill-current sm:h-3 sm:w-3" data-id="element-257" data-mp="3r4a9arvue5h5" data-mpi={star} />)}</span></div><p className="mt-0.5 text-[10px] text-plum/65 sm:text-xs" data-id="element-258" data-mp="8ynqy3r67t91">{testimonial.role}</p><blockquote className="mt-1 text-[11px] leading-snug text-plum sm:text-sm" data-id="element-259" data-mp="8wkx18mwdfz1">“{testimonial.quote}”</blockquote></figcaption>
    </motion.figure>;
}